<template>
  <div class="xueqiu-news-container">
    <h3>雪球新闻</h3>
    <!-- 新增刷新控制栏 -->
    <div class="refresh-control">
      <div class="control-group">
        <label class="control-label">刷新间隔</label>
        <div class="input-number-group">
          <button 
            class="number-btn" 
            @click="decrementInterval"
            :disabled="refreshInterval <= 10"
          >-
          </button>
          <input 
            type="number" 
            v-model.number="refreshInterval"
            :min="10"
            :max="3600"
            @change="handleIntervalChange"
            class="number-input"
          >
          <button 
            class="number-btn"
            @click="incrementInterval"
            :disabled="refreshInterval >= 3600"
          >+
          </button>
          <span class="number-unit">秒</span>
        </div>
      </div>

      <div class="control-group">
        <label class="control-label">自动刷新</label>
        <div class="switch-container">
          <label class="switch">
            <input type="checkbox" v-model="isAutoRefresh" @change="handleRefreshSwitch">
            <span class="slider round"></span>
          </label>
          <span class="switch-text">{{ isAutoRefresh ? '开启' : '暂停' }}</span>
        </div>
      </div>
      
      <div class="control-group">
        <label class="control-label">雪球 Cookie</label>
        <input 
          v-model="form.cookie" 
          class="cookie-input" 
          placeholder="请输入 Cookie"
        >
      </div>
      
      <div class="control-group">
        <button
          class="refresh-btn"
          @click="manualRefresh"
          :disabled="loading"
        >
          <span class="refresh-icon" :class="{ 'loading': loading }">↻</span>
          立即刷新
        </button>
      </div>
    </div>

    <!-- 新闻列表 -->
    <div class="news-grid">
      <div v-for="item in newsList" :key="item.id" class="news-card">
        <div class="news-header">
          <h3 class="news-title">{{ extractTitle(item.text) }}</h3>
          <span class="news-time">{{ formatTime(item.created_at) }}</span>
        </div>
        <p class="news-content">{{ extractContent(item.text) }}</p>
        <div class="news-footer">
          <span class="interaction-item">
            <span class="icon">💬</span>
            {{ item.reply_count }} 评论
          </span>
          <span class="interaction-item">
            <span class="icon">↗️</span>
            {{ item.share_count }} 分享
          </span>
        </div>
      </div>
    </div>
    
    <!-- 消息提示组件 -->
    <div v-if="message.show" class="message-toast" :class="message.type">
      {{ message.text }}
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import axios from 'axios';

export default {
  data() {
    return {
      newsList: [],
      nextMaxId: null,
      refreshInterval: 15, // 默认15秒
      isAutoRefresh: true, // 自动刷新状态
      timerId: null, // 定时器ID
      loading: false, // 加载状态
      form: {
          cookie: localStorage.getItem('xueqiu_cookie') || '' // 初始化 cookie
      },
      message: {
        show: false,
        text: '',
        type: 'success'
      }
    };
  },
  mounted() {
    this.fetchNews(true);
  },
  methods: {
    // 显示消息提示
    showMessage(text, type = 'success') {
      this.message = { show: true, text, type };
      setTimeout(() => {
        this.message = { show: false, text: '', type: 'success' };
      }, 3000);
    },
    
    // 增加刷新间隔
    incrementInterval() {
      if (this.refreshInterval < 3600) {
        this.refreshInterval += 10;
        this.handleIntervalChange();
      }
    },
    
    // 减少刷新间隔
    decrementInterval() {
      if (this.refreshInterval > 10) {
        this.refreshInterval -= 10;
        this.handleIntervalChange();
      }
    },
    
    // 处理间隔变化
    handleIntervalChange() {
      // 确保值在有效范围内
      if (this.refreshInterval < 10) this.refreshInterval = 10;
      if (this.refreshInterval > 3600) this.refreshInterval = 3600;
      
      if (this.isAutoRefresh) {
        this.startAutoRefresh();
        this.showMessage(`刷新间隔已调整为${this.refreshInterval}秒`);
      }
    },
    
    handleRefreshSwitch(isActive) {
      if (isActive) {
        this.startAutoRefresh();
        this.showMessage(`已开启自动刷新，间隔${this.refreshInterval}秒`);
      } else {
        this.stopAutoRefresh();
        this.showMessage('已暂停自动刷新', 'info');
      }
    },

    startAutoRefresh() {
      this.stopAutoRefresh(); // 先停止已有定时器
      this.timerId = setInterval(() => {
        if (!this.loading) {
          this.fetchNews(true);
        }
      }, this.refreshInterval * 1000);
    },

    stopAutoRefresh() {
      if (this.timerId) {
        clearInterval(this.timerId);
        this.timerId = null;
      }
    },

    manualRefresh() {
      if (!this.loading) {
        this.fetchNews(true);
        // 注意：这里不显示成功消息，因为刷新可能失败，在fetchNews的try/catch中处理消息
      }
    },

    extractTitle(text) {
      const match = text.match(/【(.*?)】/);
      return match ? match[1] : text.slice(0, 20) + '...';
    },

    extractContent(text) {
      return text.replace(/【(.*?)】/g, '');
    },

    formatTime(timestamp) {
      return dayjs(timestamp).format('YYYY-MM-DD HH:mm');
    },

    async fetchNews(isRefresh = false) {
      try {
        this.loading = true;
        // 使用表单中的cookie或从localStorage获取
        const cookie = this.form.cookie || localStorage.getItem('xueqiu_cookie') || '__utmz=1.1709877910.1.1.utmcsr=(direct)|utmccn=(direct)|utmcmd=(none); cookiesu=111740962553404; device_id=98010cd28892388314062826e479ee22; s=c01u1pl55s; __utma=1.279012615.1709877910.1730698510.1745904479.6; HMACCOUNT=3B2844D10F77CAA2; Hm_lvt_1db88642e346389874251b5a1eded6e3=1747632634; acw_tc=ac11000117490838481065286e0061e36ef8c6901c512d04991816077ddcc1; remember=1; xq_a_token=db26bade20dd8cffc51ae807ffeaf86c8697d03e; xqat=db26bade20dd8cffc51ae807ffeaf86c8697d03e; xq_id_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJ1aWQiOjExNzcxNjQ4OTEsImlzcyI6InVjIiwiZXhwIjoxNzUxNjc1ODg4LCJjdG0iOjE3NDkwODM4ODg4NDMsImNpZCI6ImQ5ZDBuNEFadXAifQ.UqVVuaa53vwC2yeWqibFyLshXGvEjVVWH8d1ZXdy_a44Us4ZpXJd6bGAKY5FOujORhfzjKpMWmfC-LJm0O1MvwIoI1Uk9BLjVidRTw6LmV873NthuOxtP2sBYbvpj5mib5NqBAuKpD5Mzmv_WsPnSELTf4p-Kj9noZx6RHkmfcxnjGuIu5CoOpkSof-_Jn3WqYmRMB4mlaHtbymH8iMj30ikcEQe9nwQZFvB8pqiiJ56cTxST3Lhx7PAY0oYk1MHJKYkItA_D0HFNswd1LXLE28CUApq5RME3LO82D1WS3_eRnbxrYCN84vP9OHxzZnoU0FKsTMPaN8I25yAq32jAA; xq_r_token=da33c94a4e9e777ea1470d234a7a21239360116a; xq_is_login=1; u=1177164891; .thumbcache_f24b8bbe5a5934237bbc0eda20c1b6e7=VEPjETZY6zvmx+rYByjs6X+iH77PMn/JStNTXfk/z53QG7NIXxzdV32AJ0kZl+TztS+C1jhUughaFYEEJzw1wA%3D%3D; ssxmod_itna=eqGxRDgDyGArG0KYi=nPGK3g4l4C5iOD+xQ5DODLxn+xGdDues9=AGhiDGqcDQp4D9GAqI8DBkDptDnqD8LDQeDvSj4wt4c4fGuGoo=07i=5ebUMlm55VhBBgaLakK19txMDB3DEx0=7QAw5SDGGI4GwDGoD34DiDDPDbRNDAdeD7qDFCmRd2ebDm4GWCeGfDDoDYRrexitYDDtvBqG232rPS3b4DDN4DIDQ43LbapNHqE93hrcXCeDM3xGXA784CQFf6IDta6gXKZYexB=RxBQQqETVfcpYZQur5ewwQ0Y6QivtAYo7Ki5YDqeDKx2Y0DK4r5C2qoi5q0DxohKiimrdFjqDDftAptFmDchRhtc2tychZo5BARuApziGUlR4Ww8CwC0qseesYAdGDqfDqixxpNeYD; ssxmod_itna2=eqGxRDgDyGArG0KYi=nPGK3g4l4C5iOD+xQ5DODLxn+xGdDues9=AGhiDGqcDQp4D9GAqItDGfqht3O9CgRxcUpwvXG/QlCdxxD; Hm_lpvt_1db88642e346389874251b5a1eded6e3=1749085136';
        
        // 保存cookie到localStorage
        if (this.form.cookie) {
          localStorage.setItem('xueqiu_cookie', this.form.cookie);
        }

        const params = {
          count: 15,
          cookie: cookie
        };

        const { data } = await axios.post('/api/xueqiu', params);

        if (isRefresh) {
          // 去重处理
          const newItems = data.items.filter(newItem => 
            !this.newsList.some(existingItem => existingItem.id === newItem.id)
          );
          this.newsList = [...this.newsList, ...newItems];
          if (newItems.length > 0) {
            this.showMessage(`成功加载 ${newItems.length} 条新闻`);
          }
        } else {
          this.newsList = data.items;
          this.showMessage('新闻刷新成功');
        }
        // 保持分页状态
      } catch (error) {
        console.error('获取雪球新闻数据失败', error);
        this.showMessage('获取新闻数据失败', 'error');
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    // 移除原来的watch，因为我们已经在handleIntervalChange中处理了
  },
  beforeUnmount() {
    this.stopAutoRefresh();
  },
};
</script>

<style scoped>
/* 雪球新闻页面样式 */
.xueqiu-news-container {
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.xueqiu-news-container h3 {
  color: #333;
  margin-bottom: 20px;
  font-size: 20px;
}

/* 刷新控制栏样式 */
.refresh-control {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 8px;
}

.control-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.control-label {
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
}

/* 数字输入框样式 */
.input-number-group {
  display: flex;
  align-items: center;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}

.number-btn {
  width: 32px;
  height: 32px;
  border: none;
  background-color: #f5f7fa;
  color: #606266;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.number-btn:hover:not(:disabled) {
  background-color: #e6e8eb;
}

.number-btn:disabled {
  cursor: not-allowed;
  color: #c0c4cc;
}

.number-input {
  width: 60px;
  height: 32px;
  border: none;
  border-left: 1px solid #dcdfe6;
  border-right: 1px solid #dcdfe6;
  text-align: center;
  font-size: 14px;
}

.number-input:focus {
  outline: none;
}

.number-unit {
  padding: 0 8px;
  font-size: 14px;
  color: #606266;
}

/* 开关样式 */
.switch-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
}

input:checked + .slider {
  background-color: #409eff;
}

input:checked + .slider:before {
  transform: translateX(20px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.switch-text {
  font-size: 14px;
  color: #606266;
}

/* Cookie输入框样式 */
.cookie-input {
  width: 300px;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
}

.cookie-input:focus {
  outline: none;
  border-color: #409eff;
}

/* 刷新按钮样式 */
.refresh-btn {
  height: 32px;
  padding: 0 16px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 6px;
}

.refresh-btn:hover:not(:disabled) {
  background-color: #66b1ff;
}

.refresh-btn:disabled {
  background-color: #c0c4cc;
  cursor: not-allowed;
}

.refresh-icon {
  display: inline-block;
  font-size: 16px;
}

.refresh-icon.loading {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 新闻列表样式 */
.news-grid {
  display: grid;
  gap: 20px;
}

.news-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 20px;
  transition: box-shadow 0.3s;
}

.news-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.news-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 15px;
  flex-wrap: wrap;
  gap: 10px;
}

.news-title {
  font-size: 18px;
  color: #333;
  margin: 0;
  flex: 1;
  line-height: 1.4;
}

.news-time {
  color: #999;
  font-size: 14px;
  white-space: nowrap;
}

.news-content {
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
  word-break: break-word;
}

.news-footer {
  border-top: 1px solid #eee;
  padding-top: 10px;
  display: flex;
  gap: 20px;
}

.interaction-item {
  color: #909399;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.icon {
  font-size: 16px;
}

/* 消息提示样式 */
.message-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 12px 20px;
  border-radius: 4px;
  color: #fff;
  z-index: 2000;
  animation: slideInRight 0.3s ease-out;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.message-toast.success {
  background-color: #67c23a;
}

.message-toast.error {
  background-color: #f56c6c;
}

.message-toast.info {
  background-color: #909399;
}

.message-toast.warning {
  background-color: #e6a23c;
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .xueqiu-news-container {
    padding: 10px;
  }
  
  .refresh-control {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  
  .control-group {
    flex-direction: column;
    align-items: stretch;
    gap: 5px;
  }
  
  .cookie-input {
    width: 100%;
  }
  
  .refresh-btn {
    justify-content: center;
  }
  
  .news-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
  
  .news-time {
    white-space: normal;
  }
}
</style>
